import { FulfillmentGroupSchema } from "@redotech/redo-model/fulfillments/fulfillment-group";
import * as z from "zod/v4";

export const getRelevantFulfillmentGroups = {
  name: "getRelevantFulfillmentGroups" as const,
  input: z.object({ identifier: z.string() }),
  output: z.object({ fulfillmentGroups: z.array(FulfillmentGroupSchema) }),
};
